/**
 * 로그아웃 정리 훅 등록부 — authStore 가 user→null 이 되는 지점(명시 signOut·refresh 실패)에서 한 번에 부른다.
 *
 * 편집기 스토어처럼 auth 위에 얹힌 스토어는 여기 등록해 스스로 정리한다. authStore 가 그 스토어들을 가져오면
 * 진입 청크에 도메인이 실리고(트랙 A-4), 스토어가 authStore 를 가져오면 노드 테스트 환경에서 UI 의존이 딸려 온다 —
 * 그래서 양쪽 다 의존하지 않는 이 작은 등록부가 접점이다. 적재되지 않은 스토어는 등록되지 않으니 정리 대상도 아니다.
 */
const hooks = new Set<() => void>();

export function onSignOut(hook: () => void): () => void {
  hooks.add(hook);
  return () => { hooks.delete(hook); };
}

export function runSignOutHooks(): void {
  for (const hook of hooks) hook();
}
